import customerallComponent from './customer.all.component';

let customerallModule = angular.module('customerall', [
])

.component('customerall', customerallComponent)

.name;

export default customerallModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/all/index.js